"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dropdownDocumentWithOldDSResponse = void 0;
var dropdownDocument_1 = require("./dropdownDocument");
exports.dropdownDocumentWithOldDSResponse = __assign(__assign({}, dropdownDocument_1.dropdownDocument), { responses: [
        {
            answer: "Cherry",
            questionId: 1192002,
            questionRootId: 1192002,
            associatedId: 1190000,
            timeAnswered: "",
        },
    ] });
//# sourceMappingURL=dropdownDocumentWithOldDSResponse.js.map